// extracted by mini-css-extract-plugin
export default {"noMarginLeft":"noMarginLeft---vsXDn","resetButton":"resetButton---MWB6l","totalCountWrapper":"totalCountWrapper---Wxjbz","enabled":"enabled---oRZvY"};